module.exports = __webpack_public_path__ + "img/08galr.11c67c87.jpg";